import Swiper from 'swiper';

const breakpoints = {
    large: window.matchMedia('(min-width:64rem)'),
}
const classNames = {
    swiperDestroyed: 'swiper--destroyed'
}

const initPostSwiper = () => {
    const container = document.querySelector<HTMLElement>('.post-swiper')

    if (container === null) {
        return
    }

    const swiper = new Swiper(container, {
        modules: [],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });
}

const initCardsSwiper = () => {
    const swiperContainer = document.querySelector<HTMLElement>('.cards-swiper')

    if (swiperContainer === null) {
        return
    }

    const options: any = {
        modules: [],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    }

    let swiper : Swiper = new Swiper(swiperContainer, options);

    const destroySwiper = () : void => {
        swiper.destroy(true, true)
        swiperContainer.classList.add(classNames.swiperDestroyed)
    }

    const createSwiper = () : void => {
        swiper = new Swiper(swiperContainer, options)
        swiperContainer.classList.remove(classNames.swiperDestroyed)
    }

    const handleSwiperLifecycle = (e: MediaQueryListEvent): void => {
        let event: MediaQueryList | MediaQueryListEvent = breakpoints.large

        if (e) {
            event = e
        }

        if (event.matches) {
            destroySwiper()
        } else {
            createSwiper()
        }
    }

    // Handle on load breakpoint
    handleSwiperLifecycle(null)

    // Handle on change breakpoint
    breakpoints.large.addEventListener('change', (e: MediaQueryListEvent): void => {
        handleSwiperLifecycle(e)
    });
}

const initFeaturedSwiper = () => {
    const container = document.querySelector<HTMLElement>('.featured-swiper')

    if (container === null) {
        return
    }

    const swiper = new Swiper(container, {
        modules: [],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
            },
        },
    });
}

export default () => {
    initPostSwiper()
    initCardsSwiper()
    initFeaturedSwiper()
}